export default __webpack_public_path__ + "static/media/laerua-full-logo.4183fdc7.svg";